/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditChiamataDTO { 
    id?: string;
    request_time?: string;
    metodo_http?: string;
    path?: string;
    query_string?: string;
    operazione?: string;
    status_code?: number;
    actor_type?: string;
    actor_user_id?: string;
    actor_snapshot?: string;
    indirizzo_ip?: string;
    user_agent?: string;
    durata_ms?: number;
    request_body?: string;
    response_body?: string;
    allegati?: string;
    solo_lettura_eliminabile?: boolean;
}

